/** Single source of truth for exchange keys (must match backend/API). */
export const EXCHANGES = ['binance', 'bybit', 'okx', 'hyperliquid', 'lighter', 'extended'];

/** Default selected state: all exchanges enabled. */
export const DEFAULT_SELECTED = Object.fromEntries(EXCHANGES.map((e) => [e, true]));
